import { styled } from '@mui/material';

export const StyledScrollToTop = styled('div')(({ theme }) => ({
  zIndex: 11,
  position: 'fixed',
  right: theme.spacing(6),
  bottom: theme.spacing(10),
}));

export default StyledScrollToTop;
